module.exports = __webpack_public_path__ + "static/img/bruce-mars-AndE50aaHn4-unsplash_thumb.ae566ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/bruce-mars-AndE50aaHn4-unsplash_thumb.png
// module id = /kPr
// module chunks = 4